var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"min-h-screen flex items-center justify-center relative",staticStyle:{"background":"linear-gradient(to bottom, #0174EA, #013A75)","width":"100%"}},[(!_vm.contactData || _vm.contactData.length < 1)?[_c('FittLinkTree')]:[_c('PersonalLinkTreePage',{attrs:{"contact-data":_vm.contactData}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }